import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Container from '../layout/Container';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiMessageCircle, FiZap, FiCpu } = FiIcons;

export default function CTASection() {
  return (
    <section className="py-32 relative overflow-hidden bg-slate-950">
      {/* Dynamic Background Glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-[150%] bg-gradient-to-t from-indigo-500/10 via-slate-900/50 to-transparent blur-[120px] opacity-40" />
      </div>
      
      <Container>
        <motion.div 
          className="glass-card text-center relative overflow-hidden p-12 lg:p-24 group"
        >
          {/* Internal Lighting Effects */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-white/5 to-transparent opacity-50 pointer-events-none" />
          <div className="absolute -top-32 -right-32 w-96 h-96 bg-indigo-500/20 blur-[100px] rounded-full group-hover:bg-indigo-500/30 transition-colors duration-1000" />
          <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-blue-500/20 blur-[100px] rounded-full group-hover:bg-blue-500/30 transition-colors duration-1000" />
          
          <div className="relative z-10 max-w-4xl mx-auto">
            <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-indigo-400 text-xs font-black uppercase tracking-widest mb-8 backdrop-blur-sm">
              <SafeIcon icon={FiZap} className="w-3 h-3" />
              <span>Join the movement</span>
            </div>

            <h2 className="text-6xl lg:text-9xl font-black text-white mb-8 italic uppercase tracking-tighter leading-[0.9]">
              Ready to <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-blue-400">Ship?</span>
            </h2>
            
            <p className="text-xl lg:text-2xl text-slate-400 mb-12 font-medium leading-relaxed max-w-2xl mx-auto">
              Stop performing for the algorithm. Start documenting your actual work. Join 18,000+ builders today.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-5 justify-center items-center">
              <Link 
                to="/auth" 
                className="btn btn-primary px-12 py-6 text-lg flex items-center space-x-3 w-full sm:w-auto justify-center min-w-[200px]"
              >
                <span>Start Building</span>
                <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              </Link>
              
              <a 
                href="#" 
                className="btn btn-secondary px-12 py-6 text-lg flex items-center space-x-3 w-full sm:w-auto justify-center min-w-[200px] group/btn hover:bg-white/10"
              >
                <SafeIcon icon={FiMessageCircle} className="w-5 h-5" />
                <span>Join Discord</span>
              </a>
            </div>
            
            <div className="mt-12 flex items-center justify-center space-x-6 text-slate-600">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiCpu} className="w-4 h-4" />
                <span className="text-[10px] font-black uppercase tracking-widest">AI Powered</span>
              </div>
              <div className="w-1 h-1 bg-slate-800 rounded-full" />
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiZap} className="w-4 h-4" />
                <span className="text-[10px] font-black uppercase tracking-widest">Free for individuals</span>
              </div>
            </div>
          </div>
        </motion.div>
      </Container>
    </section>
  );
}